<template>
    <div id="confirmPopup" class="modal fade" role="dialog">
      <div class="modal-dialog profile-confirm-poup">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header confirmpopup-bgcolor pb-0">
            <button
              type="button"
              class="close"
              data-toggle="modal"
              data-target="#confirmPopup"
            >&times;</button>
          </div>
          <div class="modal-body confirm-body col-xs-12 pt-0">
            <div class="col-xs-12 mb-12" :class="{documentConfirmation: documentDetails}">
              {{ confirmationMessage }}
            </div>
            <div v-if="documentDetails" class="col-xs-12">
              <div class="col-xs-12 documentName mb-15">
                {{ documentDetails.document_name }}
              </div>
              <div class="col-xs-12 doc-warning">
                By uploading a new version of this document, the original document will be replaced. This action cannot be undone.
              </div>
            </div>
          </div>
          <div class="modal-footer confirmpopup-bgcolor">
            <div class="col-xs-12" v-if="!documentDetails">
              <div class="col-md-6 col-sm-6 col-xs-12 profile-footer-save">
              <button
                type="button"
                @click="closeDialog"
                class="btn btn-block emergo-green-button"
              >Continue</button>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12 p-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                @click="discardChanges"
              >Discard Changes</button>
            </div>
            </div>
            <div v-else class="col-xs-12">
              <div class="col-md-6 col-sm-6 col-xs-12">
              <button
                type="button"
                @click="uploadNewVersion(false)"
                class="btn btn-block emergo-white-button"
              >Cancel</button>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
              <button
                type="button"
                class="btn btn-block emergo-blue-button"
                @click="uploadNewVersion(true)"
              >Yes upload new version</button>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
  props: [
    'confirmationMessage',
    'isNewVersion',
    'documentDetails',
  ],
  data() {
    return {};
  },

  methods: {
    closeDialog() {
      $('#confirmPopup').modal('hide');
    },

    uploadNewVersion(isNewVersion) {
      this.$emit('closeDialogue', isNewVersion);
    },

    discardChanges() {
      this.$emit('discardChanges');
      $('#confirmPopup').modal('hide');
    },
  },
};
</script>

<style scoped>
.pb-0 {
  padding-bottom: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.w-100 {
  width: 100%;
}

.documentConfirmation {
  font-size: 20px;
  color: rgba(0, 0, 0, 0.7);
}

.doc-warning {
  font-size: 16px;
  color: #828282;
  line-height: 20px;
}

.documentName {
  font-size: 24px;
  color: #0B3C61;
  word-break: break-word;
}
.profile-footer-save {
  float: right;
}
/* .profile-confirm-poup {
  width: 600px;
} */
.confirm-body {
  /* padding: 5% 12%;
  margin-bottom: 10%; */
  margin-bottom: 25px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  /* font-size: 24px; */
  line-height: 28px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
}

.confirmpopup-bgcolor {
    background-color: #ffffff;
    border: 0px;
    border-radius: 10px;
}

.modal-header .close {
    background: unset;
    opacity: 1;
    line-height: unset;
    width: unset;
    border-radius: unset;
    color: unset;
    font-weight: 300;
    font-size: 30px;
}

@media (min-width: 768px) {
  .modal-dialog {
      width: 600px;
      margin: 30px auto;
  }
}
</style>
